const MessageActionTypes = {
  REMOVE_MESSAGE_FROM_LIST: "REMOVE_MESSAGE_FROM_LIST",
  REMOVE_SUCCESS_MESSAGE: "REMOVE_SUCCESS_MESSAGE",
  REMOVE_WARNING_MESSAGE: "REMOVE_WARNING_MESSAGE",
  REMOVE_ERROR_MESSAGE: "REMOVE_ERROR_MESSAGE",
  REMOVE_INFO_MESSAGE: "REMOVE_INFO_MESSAGE",
  SET_SUCCESS_MESSAGE: "SET_SUCCESS_MESSAGE",
  SET_WARNING_MESSAGE: "SET_WARNING_MESSAGE",
  SET_ERROR_MESSAGE: "SET_ERROR_MESSAGE",
  SET_INFO_MESSAGE: "SET_INFO_MESSAGE",
  SET_SUCCESS_CODE: "SET_SUCCESS_CODE",
}

export default MessageActionTypes
